export const registerMaxLength = (value, displayValue) => ({
    maxLength: {
        value: value,
        message: `Maximum length (${displayValue !== null && displayValue !== void 0 ? displayValue : value} characters) exceeded`,
    },
});
export const registerMultilineMaxLength = (maxCharactersCount, charactersCount) => ({
    maxLength: {
        value: maxCharactersCount,
        message: `Maximum length exceed (over ${charactersCount - maxCharactersCount} characters)`,
    },
});
